module.exports = __webpack_public_path__ + "static/img/Group_75.b64880c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Group_75.png
// module id = i1Mi
// module chunks = 97